import apiClient from './apiClient';

/**
 * @returns {Promise<Array<{ key: string, description: string, value: string, valueType: string, minValue?: number, maxValue?: number, editable: boolean }>>}
 */
export async function fetchAdminConfig() {
  const { data } = await apiClient.get('admin/config');
  return Array.isArray(data) ? data : [];
}

/**
 * @param {Record<string, string>} values
 * @returns {Promise<Array<{ key: string, description: string, value: string, valueType: string, minValue?: number, maxValue?: number, editable: boolean }>>}
 */
export async function updateAdminConfig(values) {
  const { data } = await apiClient.put('admin/config', { values });
  return Array.isArray(data) ? data : [];
}
